import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  img: {
    width: "100%",
    height: "500px",
    objectFit: "cover",
    borderRadius: "8px",
    [theme.breakpoints.down("420")]: {
      height: "300px",
    },
  },
}));

const LearnLanguage = ({ src }) => {
  const classes = useStyles();

  return (
    <div>
      <img
        src={src}
        className={classes.img}
        height="100%"
        width="100%"
        alt="learn a language"
      ></img>
    </div>
  );
};

export default LearnLanguage;
